import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { Link } from "../../Button/Link/Link";
import styles from "./SkipLinks.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SkipLinks = function SkipLinks(_ref) {
  var _ref$skipToFooterText = _ref.skipToFooterText,
    skipToFooterText = _ref$skipToFooterText === void 0 ? 'Skip to footer' : _ref$skipToFooterText,
    skipToFooterAttributes = _ref.skipToFooterAttributes,
    _ref$skipToMainText = _ref.skipToMainText,
    skipToMainText = _ref$skipToMainText === void 0 ? 'Skip to main content' : _ref$skipToMainText,
    skipToMainTextAttributes = _ref.skipToMainTextAttributes;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var onBlur = function onBlur() {
    return setIsFocused(false);
  };
  var onFocus = function onFocus() {
    return setIsFocused(true);
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.skipLinksWrapper, isFocused ? styles.skipLinksFocusWithin : styles.skipLinksInvisible),
    "data-e2e-name": "skip_links_wrapper",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
          url: "#main",
          className: styles.skipLinksLink,
          onFocus: onFocus,
          onBlur: onBlur
        }, skipToMainTextAttributes), {}, {
          children: skipToMainText
        })), /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
          url: "#footer",
          className: styles.skipLinksLink,
          onFocus: onFocus,
          onBlur: onBlur
        }, skipToFooterAttributes), {}, {
          children: skipToFooterText
        }))]
      })
    })
  });
};